module.exports = __webpack_public_path__ + "img/about-applications-bg-mobile.bf7241f1.png";